
import FormatGroupTable from "@/components/pages/contract/TradeContractFormatGroup/FormatGroupTable.vue";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import {defineComponent, PropType} from "vue";
import {TradeContractFormatGroup} from "@/store/modules/hcs/tradeContractFormatGroup/model";
import IconBtn from "@/components/molecules/IconBtn.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import TradeContractFormatGroupForm
  from "@/components/pages/contract/TradeContractFormatGroup/TradeContractFormatGroupForm.vue";
import SelectedFormatTab from "@/components/pages/contract/TradeContractFormatGroup/SelectedFormatTab.vue";
import IconBtns from "@/components/molecules/IconBtns";
import CreateTradeContractForm
  from "@/components/pages/contract/TradeContractCreate/CreateTradeContractForm.vue";
import {mapGetters, mapMutations} from "vuex";
import {AxiosInstance} from "axios";
import {TradeContract} from "@/store/modules/hcs/tradeContract/model";

const initialData = Object.freeze({
  name: '',
  description: '',
});

export default defineComponent({
  name: 'FormatGroupTab',
  components: {
    CreateTradeContractForm,
    IconBtns,
    SelectedFormatTab,
    TradeContractFormatGroupForm,
    SimpleDialog,
    IconBtn,
    FormatGroupTable, TabItemTemplate,
  },
  inject: ['tabItemBounds'],
  props: {
    groups: {
      type: Array as PropType<TradeContractFormatGroup[]>,
      required: true,
    }
  },
  data() {
    return {
      previewDialog: {
        visible: false,
        group: {} as TradeContractFormatGroup,
      },
      createDialog: {
        visible: false,
        group: {} as TradeContractFormatGroup,
        data: {
          ...initialData
        },
      }
    };
  },
  computed: {
    ...mapGetters({
      hcsClient: 'hcs/client',
    }),
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    handlePreviewButtonClick(row: TradeContractFormatGroup) {
      this.previewDialog = {
        visible: true,
        group: row,
      }
    },
    handleCreateButtonClick(row: TradeContractFormatGroup) {
      this.createDialog = {
        visible: true,
        group: row,
        data: {
          ...initialData
        },
      }
    },
    async handleCreateDialogClose(apply: boolean) {
      if(apply) {
        const hcsClient = this.hcsClient as AxiosInstance;
        const group = this.createDialog.group;
        const data = this.createDialog.data;

        try {
          this.showSnackbar({
            message: `取引契約 ${data.name} の作成中...`,
            timeout: false,
            loading: true
          });

          const {data: result} = await hcsClient.post<TradeContract[]>(`/trade_contract_format_groups/${group.id}/contracts`, {
            ...data,
            sendType: undefined,
          });

          this.showSnackbar({
            message: `取引契約 ${data.name} を作成しました`,
          });

          // 取引起案画面に遷移
          await this.$router.push({
            name: (() => {
              switch (result[0].contractType) {
                case 'draft':
                  return '/draftContract';
                case 'recruitment':
                  return '/publishContract';
                case 'offer':
                  return '/offerContract';
              }
            })(),
            params: {
              tradeContractId: result[0].id
            }
          });
        } catch (e) {
          console.error(e);
          this.showSnackbar({
            color: 'failed',
            message: `取引契約 ${data.name} の作成に失敗しました`,
          });
        }
      }
      this.createDialog.visible = false;
    }
  },
});
